module.exports = __webpack_public_path__ + "img/guangbo.fa3c7bb7.png";